import { FC } from "react";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { NewBroker } from "./newBroker";
import { BrokersRoutes } from "./routes";
import { RequireCreateBroker } from "../../auth/RequireCreateBroker";

type Props = {};

export const Brokers: FC<Props> = () => {
  return (
    <Box
      display="flex"
      position="absolute"
      top={0}
      right={0}
      bottom={0}
      left={0}
      padding={2}
    >
      <BrokersRoutes />
      <Routes>
        <Route
          path="new"
          element={
            <RequireCreateBroker>
              <NewBroker />
            </RequireCreateBroker>
          }
        />
      </Routes>
    </Box>
  );
};
